import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent
} from '@angular/common/http';

import { EMPTY, Observable } from 'rxjs';
import { UtilService } from '../providers/util-service';
import { UsuarioService } from '../providers/usuario-service';
import { GestaoPcaService } from '../providers/gestao-pca-service';
import { AlertController } from 'ionic-angular';

@Injectable()
export class PcaInterceptor implements HttpInterceptor {

  constructor(private gestaoPcaService: GestaoPcaService, public alertCtrl: AlertController) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable <HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    
    let  idPca = '';
    
    const pca = this.gestaoPcaService.getPCA();

    if (pca && pca.id) {
      idPca = pca.id;
    }
    
    req = req.clone({
      setHeaders: {
        'Pca-Access-Token': idPca
      }
    });    

    return next.handle(req);
    
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pca-interceptor.ts